import InfoIcon from '@mui/icons-material/Info';
import { alpha, InputLabel, Stack, Switch, SwitchProps, Tooltip } from '@mui/material';
import styled from 'styled-components';
import variable from '../style/variable';
import { useTranslation } from 'react-i18next';

interface ISwitchCustomProps extends SwitchProps {
    label?: string;
    hidden?: boolean;
    textTooltip?: string;
}

const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: variable.green,
        '&:hover': {
            backgroundColor: alpha(variable.green, theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: variable.green,
    },
}));

const SwitchCustom = (props: ISwitchCustomProps) => {
    return (
        !props.hidden && (
            <Stack padding={'0.3rem 0rem'} justifyContent={'space-between'} direction={'row'} alignItems={'center'} flex={1}>
                <InputLabel style={{ fontSize: '0.8rem', flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                    {props.label}
                    {props.textTooltip && (
                        <Tooltip title={props.textTooltip}>
                            <InfoIcon style={{ fill: variable.green, marginLeft: '3px', height:'18px' }} fontSize='small' />
                        </Tooltip>
                    )}
                </InputLabel>
                <GreenSwitch {...props} />
            </Stack>
        )
    );
};

export default SwitchCustom;
